<template>
  <section>
    <v-container id="container" fluid>
      <v-row id="gr" align="center" justify="center" class="pt-5 pt-md-15">
        <v-col cols="12" md="8" class="pt-5 pt-md-15">
          <v-container class="fill-height">
            <v-row justify="left" class="mb-5">
              <v-col cols="11" class="py-0 mt-10 ml-md-5">
                <div class="d-inline-flex">
                  <v-img
                    contain
                    height="50"
                    class="mr-n15 mb-5 pa-0"
                    src="@/assets/logos/horz/PSI.svg"
                  ></v-img>
                </div>
                <div>
                  {{ $t("proyectos.psi") }}
                </div>
                <br>
                <div>
                  {{ $t("proyectos.psi1") }}
                </div>
                <!-- <v-btn
                  href="http://generarecetas.com"
                  target="_blank"
                  class="accent my-5"
                  >Ver sitio</v-btn
                > -->
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col
          cols="12"
          md="4"
          align-self="center"
          class="pt-5 pt-md-15 shape verdeFondo"
        >
          <v-img
            contain
            height="300"
            src="@/assets/img/proyectos/psi/psi_img.png"
          >
          </v-img>
        </v-col>
        <div class="my-10">
          <v-btn outlined class="ma-2" to="/generarecetas"
            >Generarecetas<v-icon right>
              mdi-chevron-left
            </v-icon></v-btn
          >
          <v-btn outlined class="ma-2" to="/huella"
            ><v-icon left> mdi-chevron-right </v-icon>Huella</v-btn
          >
        </div>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "PSI",
};
</script>

<style scoped>
#gr {
  min-height: 100vh;
}

.shape {
  border-radius: 30% 70% 67% 33% / 30% 30% 70% 70%;
  background-position: top right;
  width: 200px;
  padding: 15px 0px 0px 0px
}
</style>
